import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function LastBatchTotal({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Last Batch Total"
      left="No"
      right="Yes"
      caption="Do you want to reset the batch total?"
    />
  );
}

export default LastBatchTotal;
